module.exports = __webpack_public_path__ + "static/media/rick-and-morty-dog.bdf58b5d.png";